import AppCache from "../../Helper/Common/AppCache";

export const getBmsFaultErrorCodesHeader = () => {
  if (AppCache.getItem('activeDashboard') === 'coulomb') return {};
  const config = AppCache.getItem("customObservabilityConfig") || {};
  // Prefer globalConfig["bmsFaults.allowedTags"]; fall back to legacy bmsFaults.allowedTags
  const allowedTags =
    config.globalConfig?.["bmsFaults.allowedTags"] ??
    config.bmsFaults?.allowedTags;
  const tags = Array.isArray(allowedTags) ? allowedTags : (allowedTags ? [allowedTags] : []);
  return tags.length ? { BMSFaultsTagFilter: btoa(JSON.stringify(tags)) } : {};
};
